export const LimitUserName = (userName: string): string => {
    //check username
    let checkedUserName = userName ?? '';
    if (checkedUserName.length > 21) {
        checkedUserName = checkedUserName.substring(0, 12);
        checkedUserName = checkedUserName.concat('...');
    }

    return checkedUserName ?? '';
};